import { FC, useRef } from 'react';

import { IconButton, Modal, ModalContent, ModalOverlay, rem, SearchAltOutline, Tooltip, useDisclosure } from '@bonusly/design-system';

import { useKeyboardTrigger } from '../../hooks/useKeyboardTrigger';
import { useScreenSize } from '../../hooks/useScreenSize';
import { SearchContent } from './SearchContent';
import { TooltipContent } from './TooltipContent';

export const SearchModal: FC = () => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const { isAtLeastSm } = useScreenSize();
	const buttonRef = useRef(null);

	useKeyboardTrigger('k', onOpen, { meta: true });

	return (
		<>
			<Tooltip label={<TooltipContent />} isDisabled={!isAtLeastSm}>
				<IconButton
					_active={{ bg: 'gray.100', transform: 'scale(0.95)' }}
					_hover={{ bg: 'gray.100' }}
					aria-label="Search"
					backgroundColor="gray.50"
					borderRadius="full"
					color="gray.900"
					fontSize="lg"
					boxSize={{ base: rem(40), xs: rem(44) }}
					icon={<SearchAltOutline size="md" />}
					id="primary-nav-search"
					onClick={onOpen}
				/>
			</Tooltip>

			<Modal finalFocusRef={buttonRef} isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="2xl">
				<ModalOverlay />
				<ModalContent
					maxH={`min(calc(100% - 7.5rem), ${rem(664)})`}
					{...(!isAtLeastSm && {
						height: 'auto',
						maxHeight: '100%',
						borderRadius: 0,
						maxH: 'auto',
						my: 0,
					})}
				>
					<SearchContent onClose={onClose} />
				</ModalContent>
			</Modal>
		</>
	);
};
